export default __webpack_public_path__ + "static/media/crudspace.db6a982a.mp4";